// extracted by mini-css-extract-plugin
export default {"smallModuleHead":"index_smallModuleHead_YpUjY","title":"index_title_kPCJE","zggd":"index_zggd_WfV-2","more":"index_more_GVMBr"};